const SettingCardSkeleton = () => (
  <section className="animate-pulse rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
    <div className="h-4 w-48 rounded bg-slate-200" />
    <div className="mt-3 h-3 w-full max-w-xl rounded bg-slate-100" />
    <div className="mt-6 flex items-end gap-3">
      <div className="h-10 w-36 rounded-lg bg-slate-200" />
      <div className="h-10 w-20 rounded-lg bg-slate-100" />
    </div>
  </section>
)

export default SettingCardSkeleton
